export function getCompleteSizes(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return {
    width: width,
    minWidth: width,
    maxWidth: width,
    height: height,
    minHeight: height,
    maxHeight: height
  };
}